import { Routes, Route, useLocation, Navigate, Outlet } from 'react-router-dom'

// import TasksDashboard from './pages/dashboard/view/TasksDashboard'
import MyTasks from './pages/my-tasks/view/MyTasks'
import ProjectTracker from './pages/project-tracker/view/ProjectTracker'
import Leaderboard from './pages/leaderboard/view/Leaderboard'
// import PageNotFound404 from 'components/reusable/404/PageNotFound404'

const TaskRoutes = () => {
    let location = useLocation()
    let state = location.state

    return (
        <>
            <Routes location={state?.backgroundLocation || location}>
                <Route index element={<Navigate to="dashboard" />} />
                <Route path="/" element={<Outlet />}>
                    {/* <Route path="dashboard" element={<TasksDashboard />} /> */}
                    <Route path="my-tasks" element={<MyTasks />} />
                    <Route path="project-tracker" element={<ProjectTracker />} />
                    <Route path="leaderboard" element={<Leaderboard />} />
                </Route>
                {/* <Route path="*" element={<PageNotFound404 />} /> */}
            </Routes>

            {state?.backgroundLocation && (
                <Routes>
                    <Route path="/" element={<Outlet />}>
                        {/* Modal routes can be added here later */}
                    </Route>
                </Routes>
            )}
        </>
    )
}

export default TaskRoutes